import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { Textbox, Textarea } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";

import { AutoComplete } from "primereact/autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import addMonths from "date-fns/addMonths";
import { InputText } from "primereact/inputtext";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

class Rehabilitation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pno: "",
      name: "",
      nameSuggestions: null,
      nameList: [],
      date: "",
      desc: "",
      qty: 1,
      listClass: "collapse",
      list: []
    };

    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentDidMount() {
    this.LoadNames();
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/patient/getNames"
      )
      .then((response) => {
        this.setState({ patientList: response.data });
        let nameData = response.data;
        nameData.forEach(function (item) {
          _nameList.push("[" + item.pno + "] " + item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter((t) => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {
    return (
      <div>
        <div>
          <h3 align="center">Rehabilitation</h3>
        </div>
        <div className="container-fluid" >
          <div className="row p-1 border">
            <div className="col col-md-1">Patient</div>
            <div className="col col-md-4">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
              />
            </div>
            <div className="col col-md-1 border-right" />
            <div className="col col-md-1">Date</div>
            <div className="col col-md-4">
              <DatePicker
                selected={this.state.date}
                onChange={this.handleDateChange}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={addMonths(new Date(), 6)}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-1">Description</div>
            <div className="col col-md-4">
              <InputText
                type="text"
                value={this.state.desc}
                onChange={e => this.setState({ desc: e.target.value })}
                style={{ width: "300px" }}
              />
            </div>
            <div className="col col-md-1 border-right" />
            <div className="col col-md-1">Quantity</div>
            <div className="col col-md-4">
              <InputText
                type="text"
                keyfilter="pint"
                value={this.state.qty}
                onChange={e => this.setState({ qty: e.target.value })}
                style={{ width: "300px" }}
              />
            </div>
          </div>
          <div className="row p-1 border">
            <button
              onClick={this.onSaveClick}
              className="btn btn-primary btn-md mr-2"
            >
              Save
            </button>
          </div>

          <div className={this.state.listClass}>
            <div
              className="col col-md-12 ag-theme-blue"
              style={this.getHeight()}
            >
              <AgGridReact
                rowData={this.state.list}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={this.onGridReady}
                paginationAutoPageSize={true}
              >
                <AgGridColumn field="_id" hide="true" />
                <AgGridColumn
                  field="date"
                  headerName="Date"
                  width={130}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.dateFormatter}
                />
                <AgGridColumn
                  field="desc"
                  headerName="Description"
                  width={250}
                  sortable
                  resizable
                  filter
                  editable
                  onCellValueChanged={this.descChanged}
                />

                <AgGridColumn
                  field="qty"
                  headerName="Quantity"
                  width={200}
                  sortable
                  resizable
                  filter
                  editable
                  onCellValueChanged={this.qtyChanged}
                />

                <AgGridColumn
                  width={130}
                  headerName="Update"
                  cellRendererFramework={this.renderButton}
                />
              </AgGridReact>
            </div>
          </div>


          <Growl ref={(el) => (this.growl = el)} />
        </div>
      </div>
    );
  }

  renderButton = params => {
    return (
      <p>
        <a
          onClick={this.onUpdateClick}
          className="text-primary"
          desc={params.data.desc}
          qty={params.data.qty}
          _id={params.data._id}
        >
          Click Here
        </a>
      </p>
    );
  };

  onUpdateClick = e => {
    var res = window.confirm("Are you sure to proceed ?");
    if (res == true) {
      var id = e.target.getAttribute("_id");
      var oldDesc = e.target.getAttribute("desc");
      var oldQty = e.target.getAttribute("qty");

      var desc =
        this.state[`Desc_${id}`] === undefined
          ? oldDesc
          : this.state[`Desc_${id}`];
      var qty =
        this.state[`Qty_${id}`] === undefined
          ? oldQty
          : this.state[`Qty_${id}`];

      if (this.state.pno === "") {
        this.growl.show({
          severity: "error",
          summary: "Error !!",
          detail: "Invalid Input !!"
        });
      } else {
        const obj = {
          desc: desc,
          qty: qty
        };

        axios
          .put(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/patient/rehabilitation/" + id,
            obj
          )
          .then(res => {
            this.setState({ [`Desc_${id}`]: "" });
            this.setState({ [`Qty_${id}`]: 1 });
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Data Updated !!!"
            });
          })
          .catch(error => {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Something went wrong !!"
            });
          });
      }
    }
  };

  descChanged = params => {
    this.setState({ [`Desc_${params.data._id}`]: params.data.desc });
  };

  qtyChanged = params => {
    this.setState({ [`Qty_${params.data._id}`]: params.data.qty });
  };

  handleDateChange(date) {
    this.setState({ date });
  }

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  getHeight() {
    var hgt = window.innerHeight - 275;
    return { height: hgt + "px" };
  }

  onNameSelect = (e) => {

    let p = e.value.split("] ");
    let pno = p[0].replace("[", "");

    let results = this.state.patientList.filter((t) => {
      return t.pno.toLowerCase() === pno.toLowerCase();
    })[0];
    this.setState({
      pno: pno
    });
    this.LoadList(pno);
  };

  LoadList(pno) {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/rehabilitation/" +
        pno.replace("/", "-")
      )
      .then(response => {
        this.setState({
          listClass: "row p-1 border",
          list: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  onNameChange = (e) => {
    this.Clear();
    this.setState({
      name: e.value,
      listClass: "collapse",
      list: []
    });
  };

  Clear() {
    this.setState({
      date: null,
      desc: "",
      qty: 1
    });
  }

  onSaveClick = e => {
    e.preventDefault();

    if (
      this.state.pno === "" ||
      this.state.date === null ||
      this.state.desc === ""
    ) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input  !!"
      });
    } else {
      let obj = {
        pno: this.state.pno,
        date: this.state.date,
        desc: this.state.desc,
        qty: this.state.qty
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/patient/rehabilitation/",
          obj
        )
        .then(res => {
          this.Clear();
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Details Updated !!!"
          });

          this.LoadList(this.state.pno);

        });
    }
  };

}

export default Rehabilitation;
